import { motion } from "framer-motion";
import { MessageCircle, Fingerprint, BarChart3, Check } from "lucide-react";

export default function LandingBentoFeatures() {
  return (
    <section className="relative py-24 bg-dark-primary overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-32">
            
            {/* Feature 1 */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
                <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                >
                    <div className="inline-flex items-center gap-2 px-3 py-1 bg-dark-secondary rounded-full border border-dark-border mb-6">
                        <MessageCircle size={16} className="text-functional-success" />
                        <span className="text-sm font-medium text-text-secondary">WhatsApp Integration</span>
                    </div>
                    <h3 className="text-4xl md:text-5xl font-extrabold font-outfit text-text-primary uppercase mb-6">
                        No More <br/>Missed Payments.
                    </h3>
                    <p className="text-xl text-text-secondary font-light mb-8 max-w-md">
                        Subscribers receive invoices and reminders directly on WhatsApp. Higher open rates, faster payments.
                    </p>
                    <ul className="space-y-3">
                        {["Instant Invoice Delivery", "One-Click Payment Links", "Expiry Alerts"].map(item => (
                            <li key={item} className="flex items-center gap-3 text-text-primary">
                                <Check size={18} className="text-golden-accent" />
                                {item}
                            </li>
                        ))}
                    </ul>
                </motion.div>
                <motion.div
                   initial={{ opacity: 0, scale: 0.95 }}
                   whileInView={{ opacity: 1, scale: 1 }}
                   viewport={{ once: true }}
                   className="relative bg-dark-secondary/10 rounded-3xl p-8 border border-dark-border/30 aspect-square flex items-center justify-center"
                >
                    {/* Abstract visual/mockup placeholder */}
                    <div className="text-center space-y-4 opacity-50">
                        <MessageCircle size={64} className="mx-auto text-functional-success" />
                        <div className="text-sm font-mono text-functional-success">WhatsApp API Connected</div>
                    </div>
                </motion.div>
            </div>

            {/* Feature 2 (Reversed) */}
             <div className="grid lg:grid-cols-2 gap-12 items-center">
                <motion.div
                   initial={{ opacity: 0, scale: 0.95 }}
                   whileInView={{ opacity: 1, scale: 1 }}
                   viewport={{ once: true }}
                   className="relative bg-dark-secondary/10 rounded-3xl p-8 border border-dark-border/30 aspect-square flex items-center justify-center order-2 lg:order-1"
                >
                     <div className="text-center space-y-4 opacity-50">
                        <Fingerprint size={64} className="mx-auto text-golden-accent" />
                        <div className="text-sm font-mono text-golden-accent">KYC Verified</div>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, x: 30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    className="order-1 lg:order-2 ml-auto lg:ml-12"
                >
                    <div className="inline-flex items-center gap-2 px-3 py-1 bg-dark-secondary rounded-full border border-dark-border mb-6">
                        <Fingerprint size={16} className="text-golden-accent" />
                        <span className="text-sm font-medium text-text-secondary">Security & Compliance</span>
                    </div>
                    <h3 className="text-4xl md:text-5xl font-extrabold font-outfit text-text-primary uppercase mb-6">
                        SEBI Compliant <br/>Authentication.
                    </h3>
                    <p className="text-xl text-text-secondary font-light mb-8 max-w-md">
                        Automated KYC collection via DigiLocker integration. Protect your business with verified subscribers.
                    </p>
                     <ul className="space-y-3">
                        {["Aadhaar & PAN Verification", "Digital Agreement Signing", "Audit Logs"].map(item => (
                            <li key={item} className="flex items-center gap-3 text-text-primary">
                                <Check size={18} className="text-golden-accent" />
                                {item}
                            </li>
                        ))}
                    </ul>
                </motion.div>
            </div>
            
             {/* Feature 3 */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
                <motion.div
                    initial={{ opacity: 0, x: -30 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                >
                    <div className="inline-flex items-center gap-2 px-3 py-1 bg-dark-secondary rounded-full border border-dark-border mb-6">
                         <BarChart3 size={16} className="text-functional-info" />
                        <span className="text-sm font-medium text-text-secondary">Analytics</span>
                    </div>
                    <h3 className="text-4xl md:text-5xl font-extrabold font-outfit text-text-primary uppercase mb-6">
                        Data That Drives <br/>Growth.
                    </h3>
                    <p className="text-xl text-text-secondary font-light mb-8 max-w-md">
                        Track revenue, churn, and subscriber growth in real-time. Make informed decisions instantly.
                    </p>
                    <ul className="space-y-3">
                        {["MRR & ARR Tracking", "Churn Analysis", "Subscriber Lifecycle"].map(item => (
                            <li key={item} className="flex items-center gap-3 text-text-primary">
                                <Check size={18} className="text-golden-accent" />
                                {item}
                            </li>
                        ))}
                    </ul>
                </motion.div>
                 <motion.div
                   initial={{ opacity: 0, scale: 0.95 }}
                   whileInView={{ opacity: 1, scale: 1 }}
                   viewport={{ once: true }}
                   className="relative bg-dark-secondary/10 rounded-3xl p-8 border border-dark-border/30 aspect-square flex items-center justify-center"
                >
                     <div className="text-center space-y-4 opacity-50">
                        <BarChart3 size={64} className="mx-auto text-functional-info" />
                        <div className="text-sm font-mono text-functional-info">200% Growth</div>
                    </div>
                </motion.div>
            </div>

        </div>
    </section>
  );
}
